import { TemplateClassNames } from '@/types/template-layouts.types';
import { Templates } from '@/types/template.types';
import layoutImages from '@utils/modules/layout-images.json';

export const getDefaultAgendaImage = (template: string | number | undefined, index: number): string => {
  //We want three rotating images as defaults, we need to turn any index number into either 1, 2, or 3. Modulo magic to the rescue! Contact Scott Harlan for an explination if you want to.
  const convertedIndex = String((index % 3) + 1);
  function getEndpointKey() {
    if (typeof template === 'number') {
      switch (template) {
        case Templates.O2:
          return `O2-Agenda-default_image_${convertedIndex}`;
        case Templates['Studio 54']:
          return `Studio_54-Agenda-default_image_${convertedIndex}`;
        case Templates.Apollo:
        default:
          return `red-blue-bubbles-${(index % 2) + 1}`;
      }
    } else {
      switch (template) {
        case TemplateClassNames.O2:
          return `O2-Agenda-default_image_${convertedIndex}`;
        case TemplateClassNames['Studio 54']:
          return `Studio_54-Agenda-default_image_${convertedIndex}`;
        case TemplateClassNames.Apollo:
        default:
          return `red-blue-bubbles-${(index % 2) + 1}`;
      }
    }
  }
  // redeclaring the type here so we can use the template literals above
  const _defaultImages: { [key: string]: string } = layoutImages;
  const endpoint = _defaultImages[getEndpointKey()];
  return `${import.meta.env.VITE_ASSET_SERVER}/template-previews/${endpoint}`;
};
